import React from 'react';
import {Banner, Benefit, ContactForm, Example, Offers, PromotionBanner, Sites, Step} from "./components";
import {HomeProvider} from "./HomeContext";
import Header from "./components/header/Header";
import {Footer} from "layouts/shared";
import {useOffers} from "hooks/useOffers";
import clsx from "clsx";
import {useSendContact} from "../../hooks/useSendContact";

import styles from './Home.module.scss';

const Home = (props) => {
    const {coupons = [], promotions = []} = useOffers();
    const {sendContactInfo} = useSendContact();

    return (
        <div className={clsx("h-full overflow-y-auto h-full w-full flex justify-between flex-col", styles.container)}
             id="home-body">
            <PromotionBanner promotions={promotions} coupons={coupons}/>
            <Offers promotions={promotions}/>
            <HomeProvider>
                <Header {...props}/>
            </HomeProvider>
            <Banner/>
            <Benefit/>
            <Step/>
            <Example/>
            <ContactForm sendContactInfo={sendContactInfo}/>
            <Sites/>
            <Footer/>
        </div>
    );
}

export default Home;

